module.exports = __webpack_public_path__ + "img/introduce4.dcb5928b.png";